module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all-italy.7a15f572.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all-italy.png
// module id = 2616
// module chunks = 11